/* ==========================================================================
   ÜRÜN — galeri, varyant seçici, mobil sabit sepet çubuğu
   ========================================================================== */

(function () {
  'use strict';

  var theme = window.theme || {};

  /* ----------------------------------------------------------- Para formatı */

  function formatMoney(cents) {
    var format = theme.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return format
      .replace(/\{\{\s*amount\s*\}\}/g, whole + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, whole.replace(/,/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole.replace(/,/g, '.'));
  }

  /* ------------------------------------------------------------------ Galeri */

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;

    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;

    main.removeAttribute('srcset');
    main.src = thumb.getAttribute('data-src');
    main.alt = thumb.getAttribute('data-alt') || '';

    var all = document.querySelectorAll('[data-gallery-thumb]');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active');
    thumb.classList.add('is-active');

    /* Aktif küçük görsel şerit dışına taşarsa görünür alana kaydır */
    if (thumb.scrollIntoView) {
      thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  });

  /* Sağ/sol oklar — aktif küçük görselden komşusuna geçer, başa/sona sarar */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-gallery-prev], [data-gallery-next]');
    if (!arrow) return;

    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    if (thumbs.length < 2) return;

    var current = 0;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('is-active')) { current = i; break; }
    }

    var step = arrow.hasAttribute('data-gallery-next') ? 1 : -1;
    var next = (current + step + thumbs.length) % thumbs.length;
    thumbs[next].click();
  });

  /* --------------------------------------------------------- Varyant seçici */

  function initVariants() {
    var picker = document.querySelector('[data-variant-picker]');
    if (!picker) return;

    var dataEl = picker.querySelector('[data-variant-data]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var selects = picker.querySelectorAll('[data-option-index]');

    picker.addEventListener('change', function () {
      var chosen = [];
      for (var i = 0; i < selects.length; i++) chosen.push(selects[i].value);

      var match = null;
      for (var v = 0; v < variants.length; v++) {
        var options = variants[v].options;
        var same = true;
        for (var o = 0; o < chosen.length; o++) {
          if (options[o] !== chosen[o]) { same = false; break; }
        }
        if (same) { match = variants[v]; break; }
      }

      applyVariant(match);
    });
  }

  function applyVariant(variant) {
    var idInput = document.querySelector('[data-variant-input]');
    var button = document.querySelector('[data-add-button]');
    var priceTarget = document.querySelector('[data-price-target]');

    if (!variant) {
      if (button) {
        button.disabled = true;
        button.textContent = theme.strings.sold_out;
      }
      return;
    }

    if (idInput) idInput.value = variant.id;

    if (button) {
      button.disabled = !variant.available;
      button.textContent = variant.available
        ? button.getAttribute('data-label-add') || button.textContent
        : theme.strings.sold_out;
    }

    if (priceTarget) {
      var html = '';
      if (!variant.available) {
        html = '<div class="price"><span class="price__stamp price__stamp--sold">' +
          theme.strings.sold_out + '</span></div>';
      } else {
        html = '<div class="price">';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
        }
        html += '<span class="price__stamp">' + formatMoney(variant.price) + '</span></div>';
      }
      priceTarget.innerHTML = html;
    }

    /* URL'i varyanta göre güncelle — sayfa yenilenmez */
    var root = document.querySelector('[data-product-root]');
    if (root && window.history.replaceState) {
      var url = root.getAttribute('data-url') + '?variant=' + variant.id;
      window.history.replaceState({}, '', url);
    }
  }

  /* -------------------------------------------- Mobil sabit sepet çubuğu */

  function initStickyBuy() {
    var bar = document.querySelector('[data-sticky-buy]');
    var buyBlock = document.querySelector('.product__buy');
    if (!bar || !buyBlock) return;

    var trigger = bar.querySelector('[data-sticky-add]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        var form = document.querySelector('form.product-form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -80px 0px' });

    observer.observe(buyBlock);
  }

  function init() {
    initVariants();
    initStickyBuy();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  document.addEventListener('shopify:section:load', init);
})();
